import { ImResponse, resolve, doorClient } from '.';

export function fetch() {
  return resolve(
    doorClient.get<ImResponse<Assistant.Priority>>('/overseaim-store-home/v1/org-config/priority'),
  );
}

export function update(body: Assistant.Priority) {
  return resolve(doorClient.post('/overseaim-store-home/v1/org-config/priority', body));
}
